import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetNewsListLoading, EGetNewsListActionType } from './types';

export const getNewsListLoading: () => TGetNewsListLoading = actionGenerator<EGetNewsListActionType.Loading>(
  EGetNewsListActionType.Loading,
);
